import React, { useState } from 'react';
import { PinturaEditor } from '@pqina/react-pintura';
import '@pqina/pintura/pintura.css';
import {
  getEditorDefaults,
  createDefaultImageReader,
  createDefaultImageWriter,
  plugin_crop,
  plugin_finetune,
  plugin_filter,
  plugin_annotate,
  markup_editor_locale_en_gb,
} from '@pqina/pintura';

export default function Example() {
  const [result, setResult] = useState('');
  const [editorInstance, setEditorInstance] = useState(null);

  // Custom AI action handler
  const handleAIAction = async (editor) => {
    console.log('AI button clicked from toolbar!', editor);
    // Access current image state
    const imageState = editor.imageState;
    console.log('Current image state:', imageState);
    // Add your AI logic here
  };

  // Configure editor with custom toolbar button
  const editorConfig = {
    imageReader: createDefaultImageReader(),
    imageWriter: createDefaultImageWriter(),
    plugins: [plugin_crop, plugin_finetune, plugin_filter, plugin_annotate],
    stickers: ['😎', 'sticker-one.svg', 'sticker-two.svg', 'sticker-three.svg'],

    utils: [
      'crop',
      'filter',
      // 'finetune',
      // 'annotate',
      // Custom AI button
      [
        'ai-enhance',
        {
          // icon: '<g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></g>',
          label: 'AI Enhance',
          onclick: (editor) => {
            handleAIAction(editor);
          },
        },
      ],
    ],
    locale: {
      ...markup_editor_locale_en_gb,
      utilAiEnhance: 'AI Enhance',
    },
  };

  return (
    <div>
      <h2>Pintura Editor with AI Toolbar Button</h2>

      <div style={{ height: '70vh' }}>
        <PinturaEditor
          {...editorConfig}
          src={'./image.jpeg'}
          imageCropAspectRatio={1}
          ref={setEditorInstance}
          onLoad={(res) => console.log('load image', res)}
          onProcess={({ dest }) => setResult(URL.createObjectURL(dest))}
        />
      </div>

      {!!result.length && (
        <p>
          <img src={result} alt="" />
        </p>
      )}
    </div>
  );
}
